import { useState } from 'react';
import { Button } from '../input';
import { styles } from '../../constants';
import { useGlobal } from '../../state';
import { TableFromObject } from '../table';
import { Run } from '../run';

export const Args = ({ job }) => {
  const [run, setRun] = useState();

  if (run) {
    return (
      <div style={styles.uiBox}>
        <Run endpoint={job.name} params={job.args} onRun={() => setRun(false)} />
      </div>
    );
  } else {
    return (
      <div style={{ ...styles.uiBox, display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div style={{ maxWidth: 800 }}>
          <TableFromObject obj={job.args} />
        </div>
        <div>
          <Button onClick={() => setRun(true)}>Run Again</Button>
        </div>
      </div>
    );
  }
};
